"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.add=add;exports.remove=remove;exports.clear=clear;var _constants=require("./constants");function add(){var roles=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];return{type:_constants.RRP_ADD_PERMISSION,roles:Array.isArray(roles)?roles:[roles]}}function remove(role){return{type:_constants.RRP_REMOVE_PERMISSION,role:role}}function clear(){return{type:_constants.RRP_CLEAR}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-permissions/dist/actions.js
// module id = 620
// module chunks = 3